import { Path } from '@move-frontend/contentful-routes';
import { useLocation } from './useLocation';

export function useCurrentPath() {
	const { pathname } = useLocation();

	return Path.from(pathname);
}
